angular = require('angular')

module.exports = () ->
  return {
    restrict: 'A'
    scope:
      nameVariationsDefault: '&'
      onChange: '&'

    controller: ($scope) ->
      $scope.setNameVariations = (nameVariations) ->
        $scope.nameVariations = nameVariations
        $scope.updateIsInputRequired()

      $scope.updateNameVariations = (nameVariations) ->
        nameVariations = $scope.removeEmptyVariationsExceptLast(nameVariations)
        nameVariations = $scope.appendAdditionalEmptyVariationIfRequired(nameVariations)
        $scope.setNameVariations(nameVariations)

      $scope.updateIsInputRequired = () ->
        $scope.isInputRequired = $scope.isAllNameVariationsEmpty()

      $scope.isAllNameVariationsEmpty = () ->
        $scope.nameVariations.filter((variation) -> variation.name).length == 0

      $scope.removeEmptyVariationsExceptLast = (nameVariations) ->
        lastVariation = $scope.getLastVariation(nameVariations)
        $scope.removeEmptyVariations(nameVariations.slice(0, nameVariations.length - 1)).concat(lastVariation)

      $scope.removeEmptyVariations = (nameVariations) ->
        nameVariations.filter((el) -> (el.name or '').trim())

      $scope.getLastVariation = (nameVariations) ->
        nameVariations[nameVariations.length - 1]

      $scope.appendAdditionalEmptyVariationIfRequired = (nameVariations) ->
        lastVariation = $scope.getLastVariation(nameVariations)
        if not lastVariation or (lastVariation.name or '').trim() != ''
          nameVariations.concat({name: ''})
        else
          nameVariations

      $scope.prepareForOnChange = (nameVariations) ->
        variations = $scope.removeEmptyVariations(nameVariations)
        $scope.removeHashKeys(variations)

      $scope.removeHashKeys = (nameVariations) ->
        nameVariations.map((variation) -> {name: variation.name})

      $scope.handleVariationsChange = () ->
        nameVariationsClean = $scope.prepareForOnChange($scope.nameVariations)
        $scope.onChange({nameVariations: nameVariationsClean})
        $scope.updateNameVariations($scope.nameVariations)

      nameVariations = angular.copy($scope.nameVariationsDefault())
      $scope.updateNameVariations(nameVariations)

    template: require('./name-variations-input-group.html')
  }
